import { styled } from 'styled-components';
import { useEffect, useState } from 'react';
import palette from '../../utils/colorPalette';
import { BsInfoSquareFill } from 'react-icons/bs';
import { TranslateTypography } from '../atoms';

 const InfoTooltip = ({ content, style }) => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  return (
    <TooltipContainer style={style}>
      <BsInfoSquareFill
        size={25}
        color={palette.icon.primary}
        onMouseEnter={() => setTooltipVisible(true)}
        onMouseLeave={() => setTooltipVisible(false)}
        style={{
          cursor: 'pointer',
          borderRadius: '50%',
        }}
      />
      <TooltipContent visible={isTooltipVisible}>
        <TranslateTypography variant="content2">{content}</TranslateTypography>
      </TooltipContent>
    </TooltipContainer>
  );
};

export default InfoTooltip;

const TooltipContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.div`
  /* 아이콘 스타일링 */
  display: inline-block;
`;

const TooltipContent = styled.div`
  width: 200px;
  position: absolute;
  top: 90%;
  right: calc(100% + 5px); /* 아이콘 왼쪽에 툴팁을 표시합니다. */
  transform: translateY(-50%);
  background-color: rgb(107 107 107 / 90%);
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.3s ease;
  z-index: 100;
`;
